import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
// import moment from "moment";

export const transferBagReportListState = atom({
    key: 'transferBagReportListState',
    default: [],
})

export const transferBagReportAirlineState = atom({
    key: 'transferBagReportAirlineState',
    default: [],
})

export const filtersDefault = [
    {
        label: 'Period',
        size: 6,
        required: true,
        type: 'dateRange',
        value: '',
    },
    {
        label: 'Airline',
        size: 6,
        required: true,
        type: 'select',
        value: { label: 'All Airlines', value: 'All' },
        list: [
            { label: 'All Airlines', value: 'All' },
        ]
    },
]

export const transferBagReportDataStructureState = selector({
    key: 'transferBagReportDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: "From Flight Date",
                type: "datepicker",
                order: { table: 1 },
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
            },
            { 
                label: "From Flight",
                type: "text",
                order: { table: 2 },
            },
            { 
                label: "To Flight Date",
                type: "datepicker",
                order: { table: 3 },
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
            },
            { 
                label: "To Flight",
                type: "text",
                order: { table: 4 },
            },
            { 
                label: "Total Bags",
                type: "number",
                order: { table: 5 },
            },
            { 
                label: "Bags Received",
                type: "number",
                order: { table: 6 },
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
